import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface FotoNegativa {
  fotoNegativaId: string;
  url: string;
  fotoId?: string;
}

export interface EnderecoNegativa {
  cep: string;
  logradouro: string;
  bairro: string;
  cidade: string;
  estado: string;
  complemento: string;
  numero: string;
}



export interface NegativaResponse {
  itens: any[];
  totalItens: number;
  paginaAtual: number;
  totalPaginas: number;
  tamanhoPagina: number;
}

@Injectable({
  providedIn: 'root'
})
export class NegativaService {
  private apiUrl = `${environment.cedaeapp}`;

  constructor(private http: HttpClient) { }


  /**
   * Obtém registros detalhados por período para um usuário com paginação.
   * @param usuarioId UUID do usuário (obrigatório)
   * @param dataInicio Data inicial no formato ISO (opcional)
   * @param dataFim Data final no formato ISO (opcional)
   * @param pagina Número da página (opcional)
   * @param tamanhoPagina Quantidade de itens por página (opcional)
   * @param status Status do registro (opcional)
   */
  obterTodosRegistrosPorPeriodo(
    usuarioId: string,
    dataInicio?: string,
    dataFim?: string,
    pagina?: number,
    tamanhoPagina?: number,
    status?: string
  ): Observable<any> {
    let params = new HttpParams();

    if (dataInicio) params = params.set('DataInicio', dataInicio);
    if (dataFim) params = params.set('DataFim', dataFim);
    if (pagina !== undefined) params = params.set('Pagina', pagina.toString());
    if (tamanhoPagina !== undefined) params = params.set('TamanhoPagina', tamanhoPagina.toString());
    if (status) params = params.set('status', status);

    const url = `${this.apiUrl}/buscasdetalhadas/usuarios/${usuarioId}/registros-por-periodo`;
    return this.http.get<any>(url, { params });
  }

  /**
   * Obtém todos os registros mais recentes com filtros e paginação
   * @param dataInicio Data inicial no formato ISO (opcional)
   * @param dataFim Data final no formato ISO (opcional)
   * @param pagina Número da página (opcional)
   * @param tamanhoPagina Quantidade de itens por página (opcional)
   * @param status Status do registro (opcional)
   */
  obterTodos(
    dataInicio?: string,
    dataFim?: string,
    pagina?: number,
    tamanhoPagina?: number,
    status?: string
  ): Observable<any> {
    let params = new HttpParams();

    if (dataInicio) params = params.set('DataInicio', dataInicio);
    if (dataFim) params = params.set('DataFim', dataFim);
    if (pagina !== undefined) params = params.set('Pagina', pagina.toString());
    if (tamanhoPagina !== undefined) params = params.set('TamanhoPagina', tamanhoPagina.toString());
    if (status) params = params.set('Status', status);

    const url = `${this.apiUrl}/buscasdetalhadas/todos-mais-recentes`;
    return this.http.get<any>(url, { params });
  }


  getImagemUrl(url: string): string {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    const base = environment.apiBaseUrl.replace(/\/$/, '');
    const path = url.startsWith('/') ? url : '/' + url;
    const finalUrl = base + path;
    return finalUrl;
  }
}

